import React, { Component, Fragment } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import cn from 'classnames';
import { Collapse, FormGroup } from 'reactstrap';
import { array, object, bool } from 'prop-types';
import Card from '../Card/Card';
import FlowTrackersItem from './FlowTrackersItem';
import { FMessage, FHTMLMessage } from '../../hoc/IntlComponents';
import Hint from '../Hint/Hint';

const TRACKING_PAGES = [
  {
    title: 'Prelander',
    key: 'prelanding',
  },
  {
    title: 'Landing',
    key: 'landing',
  },
  {
    title: 'Success page',
    key: 'success',
  },
];

class FlowTrackers extends Component {
  static propTypes = {
    trackers: array.isRequired,
    values: object,
    readOnly: bool,
  };

  static defaultProps = {
    trackers: [],
    values: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      fields: [],
      data: {},
      activeTab: 1,
    };
  }

  createFields = (trackers = []) => {
    return trackers.map(({ id, title, fields = [], fieldName, type, name }) => ({
      id,
      label: title,
      fields: fields,
      fieldName,
      type,
      name,
    }));
  };

  renderField = (field, index) => {
    const { values, readOnly } = this.props;
    return (
      <FlowTrackersItem
        className="flow-trackers-list-item"
        key={field.id}
        label={field.label}
        fields={field.fields}
        values={values[index]}
        onChange={this.handleChange}
        onCheck={this.handleCheck}
        readOnly={readOnly}
        page={index}
        type={field.type}
        name={field.name}
        fieldName={field.fieldName}
      />
    );
  };

  renderFields = () => {
    const { trackers } = this.props;

    return TRACKING_PAGES.map((page, index) => {
      const preparedFields = this.createFields(trackers);
      const extraFields = [];

      const gridOrder = [1, 2, 3, 4, 10, 13];
      const multiOrder = [5, 12];
      const extraOrder = [7, 6, 8, 9, 11];

      const gridFields = [];
      const multiFields = [];

      gridOrder.forEach((id) => {
        const field = preparedFields.find((item) => item.id === id);
        if (field) {
          gridFields.push(
            this.renderField(
              {
                ...field,
                fields: field.fields.slice(0, 1),
              },
              index,
            ),
          );
        }
      });

      multiOrder.forEach((id) => {
        const field = preparedFields.find((item) => item.id === id);
        if (field) {
          multiFields.push(this.renderField(field, index));
        }
      });

      extraOrder.forEach((sortId) => {
        const sortingEl = preparedFields.find((field) => field.id === sortId);
        if (sortingEl) {
          extraFields.push(this.renderField(sortingEl, index));
        }
      });

      const title = page;

      return {
        title,
        gridFields,
        multiFields,
        extraFields,
      };
    });
  };

  sortExtraFields = (fields) => {
    const orderedFields = [];
    fields.forEach((field) => {
      if ([6, 8, 9].includes(field.id)) {
        orderedFields.push(field);
      }
    });
    return orderedFields;
  };

  handleChange = ({ target }, mask, index) => {
    const regex = new RegExp(`[^${mask}]`, 'g');
    const nextValue = target.value.replace(regex, '');
    const tracker = { [target.name + '_' + index]: nextValue };
    if (target.name === 'tracking_13_pixel_id') {
      tracker[`tracking_13_event_${index}`] = nextValue ? 'purchase' : '';
    }
    const page = index;
    this.props.onTrackerChange(tracker, index);

    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [page]: {
          ...prevState.data[page],
          ...tracker,
        },
      },
    }));
  };

  handleCheck = ({ target }, index) => {
    const nextValue = target.checked;
    const tracker = { [target.name]: Number(nextValue) };
    const page = index;
    this.props.onTrackerChange(tracker, index);
    this.setState((prevState) => {
      let pageData = {};
      if (prevState.data[page]) {
        pageData = {
          ...prevState.data[page],
        };
      }
      pageData = {
        ...pageData,
        ...tracker,
      };
      if (nextValue === false) {
        delete pageData[target.name];
      }
      return {
        data: {
          ...prevState.data,
          [page]: pageData,
        },
      };
    });
  };

  handelTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };

  renderNavItems = (pages) =>
    pages.map((page) => (
      <FormattedMessage
        id={`flow.form.external-stats.tabs.${page.title.key}`}
        defaultMessage={page.title.title}
      />
    ));
  renderPanes = (pages) => {
    return pages.map((page) => {
      const isSuccessPage = page.title.key === 'success';

      return (
        <Fragment>
          <div className="flow-trackers-grid">{page.gridFields}</div>
          {isSuccessPage && (
            <div className="flow-trackers-success-note">
              <div className="flow-trackers-success-note-title">
                <span className="icon-edit" aria-hidden="true" />
                <FMessage id="flow.form.external-stats.success-note.title" />
              </div>
              <div className="flow-trackers-success-note-text">
                <FHTMLMessage id="flow.form.external-stats.success-note.text" />
              </div>
            </div>
          )}
          {page.multiFields}
          <FormGroup
            onClick={this.props.toggleTrackersDropdown}
            className={cn('pseudo-link', { isOpen: this.props.trackersDropdownOpen })}
          >
            <FMessage id="flow.form.external-stats.addition.button" />
          </FormGroup>
          <Collapse isOpen={this.props.trackersDropdownOpen}>{page.extraFields}</Collapse>
        </Fragment>
      );
    });
  };
  // renderTitle = () => (
  //   <Fragment>
  //     <FMessage id="flow.form.external-stats.title"/>
  //     <Hint id="flow-external-stats-hint" text={<FHTMLMessage id='flow.form.external-stats.hint'/>}/>
  //   </Fragment>
  // );

  render() {
    const { className } = this.props;
    const { activeTab } = this.state;
    const renderedPages = this.renderFields();
    const pages = [1, 0, 2].map((sortIndex) => renderedPages[sortIndex]);
    const title = this.props.intl.formatHTMLMessage({ id: 'flow.form.external-stats.title' });
    return (
      <Card.Tabs
        className={'flow-trackers-card-tabs ' + className}
        title={title}
        navItems={this.renderNavItems(pages)}
        panes={this.renderPanes(pages)}
        activeTab={activeTab}
        onTabChange={this.handelTabChange}
      />
    );
  }
}

export default injectIntl(FlowTrackers);
